import MuiCard from '@mui/material/Card';
import { alpha, styled } from '@mui/material/styles';
import React, { ReactNode } from 'react';

const PREFIX = 'Card';

const classes = {
  cardMui: `${PREFIX}-cardMui`
};

const Root = styled('div')(({ theme }) => ({
  [`& .${classes.cardMui}`]: {
    display: 'flex',
    backgroundColor: alpha(theme.palette.background.paper, 0.8),
    textDecoration: 'none',
    color: theme.palette.text.primary,
    '&:hover': {
      backgroundColor: alpha(theme.palette.background.paper, 0.9)
    }
  }
}));

interface CardProps {
  children: ReactNode;
  className?: string;
}

const Card = ({ children, className = '' }: CardProps) => {
  return (
    <Root sx={{ height: '100%' }}>
      <MuiCard raised className={`${classes.cardMui} ${className} `}>
        {children}
      </MuiCard>
    </Root>
  );
};

export default Card;
